import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { SessionService } from '../../shared/index';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(private sessionService: SessionService, private router: Router) { }

  ngOnInit() {
    setTimeout(() => {
      this.sessionService.externalToolbarConfig.subscribe((config) => {
        this.sessionService.isLoggingOut = true;
        this.sessionService.clear();

        if (config?.authorizationUrl) {
          window.location.replace(config.authorizationUrl);
          return;
        }

        window.location.replace('/log-in');
      })
    }, 10);
  }
}
